var map = {
	"./bonus-color.svg": 49580,
	"./cards-color.svg": 45384,
	"./favorite-color.svg": 40567,
	"./fishing-color.svg": 35595,
	"./live-color.svg": 70369,
	"./lottery-color.svg": 162,
	"./popular-color.svg": 49250,
	"./slot-color.svg": 44347,
	"./sport-color.svg": 41303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96987;